// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IIPItem,
    IMailingListRequestItem,
}                               from '../interfaces';

// ===== Enums =====

import {
    BROWSER_TYPE,
}                               from '../enums';

const createMailingListRequest = async ({
    test,
    email,
    ip,
    sessionId,
    browser,
    isMobile,
    isMacOS,
}: {
    test: boolean,
    email: string,
    ip: IIPItem,
    sessionId: string,
    browser: BROWSER_TYPE,
    isMobile: boolean,
    isMacOS: boolean,
}): Promise<IMailingListRequestItem> => {
    const functions = getFunctions();
    const handleCreateMailingListRequest = httpsCallable<
        Record<
            string,
            boolean | string | IIPItem | BROWSER_TYPE
        >,
        IMailingListRequestItem
    >(
        functions,
        'createMailingListRequest',
    );
    return handleCreateMailingListRequest({
        test,
        email,
        ip,
        sessionId,
        browser,
        isMobile,
        isMacOS,
    }).then((result) => {
        const request = result.data as IMailingListRequestItem;
        return request;
    }).catch((err) => {
        throw err;
    });
};

export default createMailingListRequest;
